const ORG_BASE_PATH = "/orgadmin/v1/";

export const Environment = {
    SELF_ONBOARD: ORG_BASE_PATH + 'self-onboard',
    STATE_FIELDS: ORG_BASE_PATH + "generic/state/fields/{state_code}"
}